import React from 'react';
import PropTypes from 'prop-types';
import IntroPopup from './IntroPopup';
import TooltipTarget from './TooltipTarget';
import platform from '../../util/platform';

export default class Tooltip extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    hover: false,
  };

  constructor() {
    super();
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
  }

  showTooltip() {
    this.setState({ hover: true });
  }

  hideTooltip() {
    this.setState({ hover: false });
  }

  render() {
    if (platform.isKiosk || !this.props.content) {
      // this isn't a tooltip-target really but this makes the less less messy
      return <div className={'tooltip-target'}>{this.props.children}</div>;
    }

    return (
      <IntroPopup
        wiggle={false}
        autoUpdate={true}
        maxLines={1}
        className="tooltip"
        showPopup={this.state.hover}
        {...this.props}
      >
        <TooltipTarget
          hover={this.state.hover}
          in={this.showTooltip}
          out={this.hideTooltip}
        >
          {this.props.children}
        </TooltipTarget>
      </IntroPopup>
    );
  }
}
